import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeclensionWordPipe } from './declension-word.pipe';

@NgModule({
  declarations: [DeclensionWordPipe],
  exports: [DeclensionWordPipe],
  imports: [CommonModule]
})
export class DeclensionWordModule {}
